module.exports = __webpack_public_path__ + "img/JGCX.e9fd35b6.png";